import { render } from "./PlusView.vue?vue&type=template&id=1c1d6c5b"
const script = {}

import "./PlusView.vue?vue&type=style&index=0&id=1c1d6c5b&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__